import Container from 'react-bootstrap/Container'
import './delivery.css'
import Footer from './Footer'

export default function Delivery(){
    return(
        <div>    
            
            <Container>
            <h3 id="pickup-title">Farmers Market Pick up</h3>
            <h5>Never Miss Out on Your Favorites</h5>
                <p>
                  We know how disappointing it is to arrive at the 
                  market only to find your favorite microgreens, artisan bread, or gourmet mushrooms already sold out!
                </p>
                <p>
                    To guarantee your weekly harvest, pre-order directly on our website. We will set aside your fresh 
                    items so all you have to do is grab your basket and go
                </p>
                <ul>
                    <li>
                        <b>Step 1:</b> Browse our shop and place your order online.
                    </li>
                    <li>
                        <b>Step 2:</b> Select "Market Pick-Up" at checkout and choose your market location.
                    </li>
                    <li>
                        <b>Step 3:</b>Pick up your reserved farm-fresh goods on market day!
                    </li>
                </ul>
                <p>
                    <b>Pre-Order Deadline:</b> Please place your market pick-up order by <b>12:00 PM on Thursdays</b> for your 
                    local market day so we can pack your order. We do back to back market days and this is the only way we can insure
                    you will have the items you would like. 
                </p>
                    
                
            <h3 id="delivery-title">Home Delivery Program</h3>
            <h6>Farm-Fresh Goodness Delivered Straight to Your Door</h6>
                <p>Can’t make it to the farmers market this weekend? We bring the 
                urban farm straight to your front porch across the Tucson metro area.
                </p>
                <h5>Delivery Details & Pricing</h5>
                <ul>
                    <li>
                        <b>Free Delivery: </b>Available on all orders over <b>$20.00</b> or with an <b>active recurring Subscription</b>!
                    </li>
                    <li>
                        <b>Standard Delivery:</b> $5.00 delivery fee for orders under $20.00.
                    </li>
                    <li>
                       <b> Delivery Day:</b> We deliver every <b>Monday</b> within the Tucson metro area.
                    </li>
                </ul>
                <p>
                   <b>Order Cutoff:</b> Place your order by <b>Thursday at 5:00 PM </b>for Monday delivery. 
                   Orders placed after Thursday at 5:00 PM will be delivered the following Monday. 

                </p>
                <p>
                    We do suggest that if you do take advantage our delivery service, please leave a cooler by the
                    door to keep your microgreens fresh. These little guys are parishable and need to be kept cool. 
                    Adding a gel pack or ice to the cooler would also be benifical. 
                </p>
                <h5>
                   <b> Porch Cooler Guidelines </b>
                </h5>
                <p>
                    Because our microgreens, gourmet mushrooms, and artisan goods are perishable and harvested fresh, they need to stay cool.
                </p>
                <p>
                    <b>Do I need to be home? </b>No! If you won't be home during delivery hours, simply leave <b>a clean cooler with ice or gel packs</b> on 
                    your front porch. Our delivery driver will place your order safely inside to keep everything chilled until you unpack.
                </p>

            <h3 id="subscription-title">Subscriptions</h3>    
            <h5>
                The Hassle-Free Way to Stay Stocked
            </h5>
                <p>
                   A recurring subscription is the easiest way to ensure a steady, regular supply 
                   of fresh whole food without lifting a finger.
                </p>
                <ul>
                    <li>
                       <b> Guaranteed Harvest: </b>Subscribing allows us to grow directly for you, so your 
                        favorite microgreens and farm products are always reserved.
                    </li>
                    <li>
                        <b>Free Home Delivery:</b> Every subscription automatically qualifies for FREE home delivery.
                    </li>
                    <li>
                        <b>Total Flexibility:</b> Easily pause, skip a week, or update your items anytime before our Thursday 5:00 PM deadline.
                    </li>
                </ul>
                
            </Container>
          
        </div>
    )
}